export const HANDLE_DURATION = 5;
export const MAX_DURATION = 5;
export const MIN_DURATION = 1;
